// extracted by mini-css-extract-plugin
export default {"Text":"BypassListRow-module__Text--eZswo","IconButton":"BypassListRow-module__IconButton--kWNGU"};